import intl from "react-intl-universal";
import { TbBuildingBank, TbChartBar, TbCreditCard, TbKey, TbUsers } from "react-icons/tb";
import { ShortcutCard } from "../../../../../Components/Atoms/ShortcutCard";
import { useBaasCapabilities } from "../../../../../Hooks/useBaasCapabilities";
import { BaasFundShellsButton } from "../../Accounts/components/BaasFundShellsButton";
import { BAAS_STABLES_METRICS_PATH } from "../../constants";
import { CARTOES_CREATE_PATH } from "../BaasCardProgramCreatePage";

const QUICK_ACTIONS = [
  {
    id: "new-entity",
    capabilityId: "entities.create",
    labelKey: "baas.home.dashboard.quickActions.newEntity",
    icon: TbBuildingBank,
    to: "/baas/entidades",
    search: "?create=1",
  },
  {
    id: "new-card-program",
    capabilityId: "issuer.programs.create",
    labelKey: "baas.home.dashboard.quickActions.newCardProgram",
    icon: TbCreditCard,
    to: CARTOES_CREATE_PATH,
  },
  {
    id: "stables-metrics",
    capabilityId: "processing.stables.view",
    labelKey: "baas.home.dashboard.quickActions.stablesMetrics",
    icon: TbChartBar,
    to: BAAS_STABLES_METRICS_PATH,
  },
  {
    id: "api-keys",
    capabilityId: "api.keys.manage",
    labelKey: "baas.home.dashboard.quickActions.apiKeys",
    icon: TbKey,
    to: "/baas/api",
  },
  {
    id: "entities",
    capabilityId: "entities.list",
    labelKey: "baas.home.dashboard.quickActions.entities",
    icon: TbUsers,
    to: "/baas/entidades",
  },
];

export const BaasHomeQuickActions = () => {
  const { can } = useBaasCapabilities();

  // Hide shortcuts the viewer cannot use — never show disabled write CTAs.
  const visibleActions = QUICK_ACTIONS.filter(({ capabilityId }) => can(capabilityId));
  const showFundShells = can("issuer.panel.view") && can("accounts.transfer");

  if (!visibleActions.length && !showFundShells) {
    return null;
  }

  return (
    <section className="min-w-0 w-full">
      <p className="dashboard-section-label mb-3">
        {intl.get("baas.home.dashboard.quickActionsSection")}
      </p>
      <div className="shortcut-scroll-row">
        {visibleActions.map(({ id, labelKey, icon, to, search }) => (
          <ShortcutCard
            key={id}
            to={to}
            search={search}
            icon={icon}
            label={intl.get(labelKey)}
          />
        ))}
        {showFundShells ? <BaasFundShellsButton variant="shortcut" /> : null}
      </div>
    </section>
  );
};
